// 自动补全/固定域名账号组件
<template>
<div>
  <!--样式1：固定后缀 不需要补全-->
  <urs-input ref="input" v-if="!showSuggest" placeholder="用户名" :name="name" @blur="onBlur" @focus="onFocus(false)" :initialValue="preFilter(initialValue)"><span class='suggest_single' slot="icon-button">{{singleSuffix}}</span></urs-input>
  <!--END 样式1-->
  <!--样式2：补全配置后缀-->
  <urs-input v-if="showSuggest" ref="input"
    :placeholder="placeholder"
    :name="name"
    @input="onShow"
    @focus="onFocus(true)"
    @blur="onBlur"
    @delete="onDelete"
    :initialValue="initialValue"
  >
  <ul v-show="open" @mousedown="onSelect" class="suggest_drop">
    <li v-for="item in items">
      <span>{{item}}</span>
    </li>
  </ul>
  </urs-input>
  <!--END 样式2-->
</div>
</template>

<script>

let generatePrompt = function (suffix, val, set) {
  let temp = suffix.split(',')
  let filterTemp = []
  let pre = val.split('@')[0]
  let suf = val.split('@')[1]

  if (set == 1 && suf !== '') {
  // val里输入了@符号且@后边有值，需要筛选域名
    for (let i = 0; i < temp.length; i++) {
      let treg = new RegExp('^@' + suf)
      // 过滤
      if (treg.test(temp[i])) {
        filterTemp.push(pre + temp[i])
      }
    }
  } else {
  // val未输入@符号或@符号后没有值，直接补充支持的后缀
    for (let i = 0; i < temp.length; i++) {
      filterTemp.push(pre + temp[i])
    }
  }
  return filterTemp
}

// 校验正则
const regemail = /^[\w-\.]+@(?:[\w-]+\.)+[a-z]{2,6}$/
const regprefix = /^[\w-\.@]+$/
export default {
  name: 'suggest',
  props: {
    placeholder: String,
    name: String,
    suffix: String,
    initialValue: String
  },
  data () {
    return {
      items: [],
      value: ''
    }
  },
  computed: {
    showSuggest () {
      return this.suffix.split(',').length > 1
    },
    open () {
      return this.items.length > 0
    },
    singleSuffix () {
      if (this.suffix.indexOf(',') === -1) {
        return this.suffix
      }
      return ''
    }
  },
  watch: {
    // 解决内层下拉框滚动时 外层跟着滚动的问题
    open (val) {
      if (val) {
        document.getElementsByTagName('html')[0].style = 'height:100%;overflow:hidden;'
        document.getElementsByTagName('body')[0].style = 'height:100%;overflow:hidden;'
      } else {
        document.getElementsByTagName('html')[0].style = 'overflow:auto;'
        document.getElementsByTagName('body')[0].style = 'overflow:auto;'
      }
    }
  },
  beforeDestroy () {
    // @NOTE 实例销毁前清除定时器
    if (this.sto) {
      window.clearTimeout(this.sto)
    }
  },
  methods: {
    onShow (val) {
      // 构造数据
      // 未输入不提示
      // 输入非法不提示（允许@符号）
      // 输入大于一个@符号
      val = val.trim()
      let set = val.match(/@/g) ? val.match(/@/g).length : 0
      if (val && regprefix.test(val) && set <= 1) {
        this.items = generatePrompt(this.suffix, val, set)
      } else {
        this.items = []
      }
    },
    onBlur (val) {
      // @NOTE 自动trim
      this.$refs.input.setCurrentValue(val.trim())
      this.sto = window.setTimeout(() => {
        this.items = []
      }, 34)
    },
    onSelect (event) {
      let item = event.target
      this.$refs.input.setCurrentValue(item.innerText)
      this.$refs.input.blur()
      this.items = []
    },
    onDelete (event) {
      this.items = []
      this.$refs.input.focus()
    },
    getValue () {
      let val = this.$refs.input.currentValue.trim()
      if (!this.showSuggest && val !== '') {
        if (val.indexOf(this.singleSuffix) === -1) { val += this.singleSuffix }
      }
      return val
    },
    onFocus (val, flag) {
      var parent = this.$parent
      if (parent && parent.$options.name == 'form-item') {
        parent.setMsg('')
        this.$emit('focus');
      }
    },
    focusInput () {
      this.$refs.input.focus()
    },
    preFilter () {
      if (this.initialValue) {
        return this.initialValue.split('@')[0]
      }
    },
    validate () {
      let val = this.$refs.input.currentValue.trim(), msg = {
          errorMsg: '',
          status: true
        }
      if (val === '') {
          // window.showError('请输入账号')
        msg.errorMsg = '请输入账号'
        msg.status = false
          // return false
        return msg
      }
        // 固定后缀
      if (!this.showSuggest) {
        if (val.indexOf(this.singleSuffix) === -1) { val += this.singleSuffix }
      }
      if (!regemail.test(val)) {
          // window.showError('账号格式错误')
          // return false
        msg.errorMsg = '账号格式错误'
        msg.status = false
      }
      return msg
    }
  }
}

</script>

<style lang="scss">
ul{
  >li{
    height: .9rem;
    line-height: .9rem;
    color: #969696;
  }
}
.suggest_drop{
  position: absolute;
  z-index: 99;
  width: 100%;
  box-sizing: border-box;
  max-height: 4.1rem;
  overflow-y: scroll;
  padding-left: .4rem;
  background-color: #ffffff;
  border-left: 1px solid #d0d0d0;
  border-right: 1px solid #d0d0d0;
  border-bottom: 1px solid #d0d0d0;
}
.suggest_single{
  display: inline-block;
  height: .4rem;
  vertical-align: top;
}
</style>




// WEBPACK FOOTER //
// Suggest.vue?4a2d5976